import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LuciMastheadsComponent } from './luci-mastheads.component';
import {LuciButtonModule} from '../luci-button/luci-button.module';
import {LuciSearchModule} from '../luci-search/luci-search.module';
import {LuciMenuModule} from '../luci-menu/luci-menu.module';



@NgModule({
  declarations: [LuciMastheadsComponent],
  exports: [LuciMastheadsComponent],
  imports: [
    CommonModule,
    LuciButtonModule,
    LuciSearchModule,
    LuciMenuModule
  ]
})
export class LuciMastheadsModule { }
